import { computed, type Ref } from 'vue';
import { formatDateToDDMMYYYY } from '@tools/dates';
import { useRelatiesGetRelationByRelatienummer } from '@services/crm-public/orval-api/relaties-api/relaties-api';
import { useWatchErrorHandler } from '@errors/useErrorHandler';

export function useFishCheckLink(relatienummer: Ref<number | null | undefined>) {
  const { data: relatiegegevens, error: relatieError } = useRelatiesGetRelationByRelatienummer(
    relatienummer,
    { query: { select: (e) => e.result } },
  );
  useWatchErrorHandler(relatieError);

  return computed(() => {
    if (!relatiegegevens.value) {
      return undefined;
    }

    const url = new URL(
      'https://www.cissystems.nl/fish/portal/Search.do?searchType=0&generiekZoeken=true&alleenSpecialeMeldingen=false&periodeVan=&periodeTot=&toonPersonenZelfdeAdres=on',
    );

    if (relatiegegevens.value.name) {
      url.searchParams.set('naam', relatiegegevens.value.name);
    }

    if (relatiegegevens.value.adres?.postcode) {
      url.searchParams.set('postCode', relatiegegevens.value.adres.postcode.replaceAll(' ', ''));
    }

    if (relatiegegevens.value.adres?.huisnummer) {
      url.searchParams.set('huisNummer', relatiegegevens.value.adres.huisnummer.toString());
    }

    if (relatiegegevens.value.adres?.huisnummertoevoeging) {
      url.searchParams.set(
        'huisNummerToevoeging',
        relatiegegevens.value.adres.huisnummertoevoeging,
      );
    }

    if (relatiegegevens.value.typeName === 'P') {
      if (relatiegegevens.value.voorletters) {
        url.searchParams.set(
          'voorletters',
          relatiegegevens.value.voorletters.replace(/[.\s]/g, ''),
        );
      }

      if (relatiegegevens.value.tussenvoegsels) {
        url.searchParams.set('voorVoegsels', relatiegegevens.value.tussenvoegsels);
      }

      if (relatiegegevens.value.geboortedatum) {
        url.searchParams.set(
          'geboorteDatum',
          formatDateToDDMMYYYY(relatiegegevens.value.geboortedatum),
        );
      }
    }

    return {
      label: 'Fish toets',
      icon: 'far fa-user-secret',
      url: url.toString(),
      target: '_blank',
    };
  });
}
